module.exports = __webpack_public_path__ + "img/navigation-pointer-01.1111e2c0.svg";